import React, { useState } from "react";
import LoadingSpinner from "../../../LoadingSpinner";

import { FiTruck } from "react-icons/fi";

const VehicleStatusVehicleInfo = ({
  activeTab,
  vehicleData,
  vehicleFeatures,
  isLoading,
}) => {
  const [activeAccordion1, setActiveAccordion1] = useState(true);

  return (
    <div
      style={{
        overflowY: "auto",
        height: "66vh",
        display: activeTab === "vehicle" ? "flex" : "none",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        padding: "1px",
      }}
      className="basic-info"
    >
      <div className="ui styled accordion" style={{ width: "100%" }}>
        <div
          className={`title ${activeAccordion1 ? "active" : ""}`}
          onClick={() => setActiveAccordion1(!activeAccordion1)}
        >
          <div>
            <span>Vehicle</span>
            <FiTruck size={14} style={{ marginLeft: "10px" }} />
            <i className="dropdown icon"></i>
          </div>
        </div>
        <div className={`content ${activeAccordion1 ? "active" : ""}`}>
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <div>
              <div className="request-info">
                <h4 className="ui dividing header">Vehicle Information</h4>
                <p>
                  <span className="label">Vehicle Code:</span>
                  <span className="value">{vehicleData.vehCode}</span>
                </p>
                <p>
                  <span className="label">Engine Capacity:</span>
                  <span className="value">{vehicleData.vehEngineCapacity}</span>
                </p>
                <p>
                  <span className="label">Chassis No:</span>
                  <span className="value">{vehicleData.vehChassisNo}</span>
                </p>
                <p>
                  <span className="label">Book Reg No:</span>
                  <span className="value">{vehicleData.vehBookRegNo}</span>
                </p>

                <p>
                  <span className="label">Manufactured Year:</span>
                  <span className="value">
                    {vehicleData.vehYearManufacturer}
                  </span>
                </p>

                <p>
                  <span className="label">Registered Year:</span>
                  <span className="value">{vehicleData.vehYearRegister}</span>
                </p>

                <p>
                  <span className="label">Vehicle No:</span>
                  <span className="value">{vehicleData.vehVehicleNo}</span>
                </p>
                <p>
                  <span className="label">Fuel Type:</span>
                  <span className="value">{vehicleData.vehFuelType}</span>
                </p>
                <p>
                  <span className="label">Manufacturer:</span>
                  <span className="value">
                    {vehicleData.vehManufacturerName}
                  </span>
                </p>
                <p>
                  <span className="label">Features:</span>
                  <span className="value">
                    {vehicleFeatures &&
                      vehicleFeatures.map((feature) => (
                        <span key={feature} className="ui label">
                          {feature.vfeDescription}
                        </span>
                      ))}
                  </span>
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VehicleStatusVehicleInfo;
